<div class="w-full h-10  flex flex-auto lg:justify-end items-center justify-between ">
  <div class="hidden lg:flex h-full w-fit justify-end items-center ">

          </div>
          <div class="w-full flex gap-1  relative justify-end items-center ">
            <div class="hidden w-fil lg:block mr-10">
            <h2 class="whitespace-nowrap  text-[var(--tertiary)] leading-6 text-[16px] font-medium font-heebo">Progresso questionario</h2>
          </div>
          <div class="size-full relative">
          <div class="flex gap-1 size-full  justify-end items-center pr-2">
            <div class="absolute top-[-4px] left-[-5px] background-stepper h-10 shadow-btn rounded-[14px]" [style.width]="width">

            </div>
            <div class="flex size-full justify-center items-center" *ngFor="let key of getCountsKeys(); let i = index" class="h-8 "[style.width]="getWidth(key)" >
              <div class="h-8" >
                <app-button [text]="(i + 1).toString()" [backgroundColor]="'var(--btn-primary)'" [color]="'var(--quaternary)'" [borderRadius]="'10'"></app-button>
              </div>
            </div>
    </div>
  </div>
      </div>  
  </div>
 